module.exports = __webpack_public_path__ + "assets/img/31.24c66999.png";